import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRouter = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	color: "none",
	viewBox: "0 0 14 14",
	id: "Router-Wifi-Network--Streamline-Flex.svg",
	height: 14,
	width: 14,
	...props,
	children: [/* @__PURE__ */ _jsx("desc", { children: "Router Wifi Network Streamline Icon: https://streamlinehq.com" }), /* @__PURE__ */ _jsxs("g", {
		id: "router-wifi-network",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 2433",
				stroke: "currentColor",
				d: "M0.5 10.2502V8.91265c0 -0.96361 0.68785 -1.78433 1.64531 -1.89298 1.15147 -0.13068 2.83669 -0.26831 4.82694 -0.26831 2.00094 0 3.70905 0.13912 4.87555 0.27041 0.9603 0.10809 1.6522 0.9307 1.6522 1.89705v1.33138c0 0.5522 -0.4477 1 -1 1h-11c-0.552285 0 -1 -0.4478 -1 -1Z",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 2434",
				stroke: "currentColor",
				strokeLinecap: "round",
				d: "M3 11.25v1",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 2435",
				stroke: "currentColor",
				strokeLinecap: "round",
				d: "M3.43213 9.25h0.5",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 2440",
				stroke: "currentColor",
				strokeLinecap: "round",
				d: "M6 9.25h0.5",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 2437",
				stroke: "currentColor",
				strokeLinecap: "round",
				d: "m1 1.75 1.5 5.20801",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 2438",
				stroke: "currentColor",
				strokeLinecap: "round",
				d: "m13 1.75 -1.5 5.20801",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 2439",
				stroke: "currentColor",
				strokeLinecap: "round",
				d: "M11 11.25v1",
				strokeWidth: 1
			})
		]
	})]
});
export default SvgRouter;
